import { PowerBiReport, TokenInfo } from "powerbi-reports/models";
import defaultAxiosClient from "shared/service/api";
import { AssertionDto, GetPowerBiAccessTokenDto, GetPowerBiReportsDto } from "./dtos";

export interface IPowerBiReportsService {
    getPowerBiAccessToken: (teamsAccessToken: string) => Promise<TokenInfo>;
    getPowerBiReports: (teamsAccessToken: string) => Promise<PowerBiReport[]>;
}

const powerBiReportsService: IPowerBiReportsService = {
    getPowerBiAccessToken: async (teamsAccessToken: string) => {
        const assertionDto: AssertionDto = { assertion: teamsAccessToken };
        const getPowerBiAccessTokenDto = await defaultAxiosClient.post<GetPowerBiAccessTokenDto>(
            "/secured/powerbi/token",
            assertionDto
        );
        const model: TokenInfo = {
            accessToken: getPowerBiAccessTokenDto.data.accessToken,
            expiresIn: getPowerBiAccessTokenDto.data.expiresIn,
        };

        return model;
    },

    getPowerBiReports: async (teamsAccessToken: string) => {
        const assertionDto: AssertionDto = { assertion: teamsAccessToken };
        const getPowerBiReportsDto = await defaultAxiosClient.post<GetPowerBiReportsDto>(
            "/secured/powerbi/report-list",
            assertionDto
        );
        const models = getPowerBiReportsDto.data.value.map(
            (dto): PowerBiReport => ({
                id: dto.id,
                name: dto.name,
                embedUrl: dto.embedUrl,
                datasetId: dto.datasetId,
                webUrl: dto.webUrl
            })
        );

        return models;
    },
};

export default powerBiReportsService;
